import React, { useState, useEffect } from "react";
import { Menu, Avatar, Dropdown } from "antd";
import Icon, { UserOutlined } from "@ant-design/icons";
import {
	LogoutOutlinedIcon,
	// @ts-expect-error sidebarIcons.jsx is untyped JSX with no declaration file
} from "../assets/sidebarIcons.jsx";
import "../Sidebar.css";
import { useDispatch, useSelector } from "react-redux";
// @ts-expect-error performLogout.js is untyped with no declaration file
import { performLogout } from "../../utils/performLogout.js";
import { RootState } from "@/store/types.js";

interface ProfilePopupProps {
  isExpanded?: boolean;
}

const ProfilePopup: React.FC<ProfilePopupProps> = ({ isExpanded = true }) => {
	const dispatch = useDispatch();
	const { user } = useSelector((state: RootState) => state.auth);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const handleLogout = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e) {
			e.stopPropagation();
		}
		// Hard-navigate (full index.html reload) so sign-out→re-login lands on the
		// latest bundle instead of this tab's stale one.
		performLogout(dispatch);
	};

  // Close dropdown when sidebar collapses
  useEffect(() => {
    if (!isExpanded) {
      setDropdownOpen(false);
    }
  }, [isExpanded]);

	return (
		<Dropdown
			destroyOnHidden={false}
			open={dropdownOpen}
			onOpenChange={setDropdownOpen}
			overlay={
        // Set a wrapped transparent div here to avoid Menu collapsing sharply
				<div className="pt-60 pr-30 pb-4">
					<Menu
						style={{
							borderRadius: "24px",
							minWidth: "200px",
							boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
							border: "1px solid #0000001f",
						}}
					>
						<Menu.Item
							key="logout"
							className="logout-menu-item"
							icon={
								<Icon
									component={LogoutOutlinedIcon}
									style={{ fontSize: "0.875rem", height: "1.25rem" }}
									className="hover:text-[#dc2626]"
									onClick={handleLogout}
								/>
							}
							style={{
								display: "flex",
								alignItems: "center",
								borderRadius: "8px",
							}}
						>
							<div
								onClick={handleLogout}
								className="flex items-center h-[2rem]"
							>
								<span className="text-[0.875rem] font-[Inter] flex flex-center">
									Log out
								</span>
							</div>
						</Menu.Item>
					</Menu>
				</div>
			}
			trigger={["click"]}
			placement="topRight"
		>
			<div className="w-full h-16 px-3 py-2 bg-white/20 rounded-[36px] shadow-[0px_4px_4px_0px_rgba(255,255,255,0.08)] outline-1 outline-offset-[-1px] outline-white/60 flex justify-between items-center cursor-pointer overflow-hidden">
				<div className="flex-1 flex justify-center items-center gap-3 overflow-hidden min-w-0">
					<Avatar
						src={user?.photoURL}
						icon={<UserOutlined />}
						className="bg-gray-500 flex-shrink-0 w-[2.75rem] h-[2.75rem]"
						style={{
							width: "2.75rem",
							height: "2.75rem",
							fontSize: "1.25rem",
						}}
					/>
					<div className="flex-1 flex flex-col justify-end overflow-hidden min-w-0">
						<div className="h-6 w-full text-left text-white/90 text-sm font-bold font-['Inter'] flex items-center">
							<span className="truncate">
								{user?.displayName || user?.email}
							</span>
						</div>
						{user?.displayName && user?.email ? (
							<div className="h-4 w-full text-left text-white/80 text-[0.75rem] font-normal font-['Inter'] flex items-center">
								<span className="truncate">{user.email}</span>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</Dropdown>
	);
};

export default ProfilePopup;
